module.exports = __webpack_public_path__ + "static/Zeitgeist-dfcf993ecfa2a519f8b0c53af3420a7d.png";